import { useState } from 'react';
import PropTypes from 'prop-types';

import { REFINEMENT_PROMPT_MAX_LENGTH } from 'utlis/constants';

const RefinementInput = ({ onSubmit, isSubmitting, disabled }) => {
  const [promptText, setPromptText] = useState('');

  const isOverLimit = promptText.length > REFINEMENT_PROMPT_MAX_LENGTH;
  const canSubmit = !isOverLimit && !isSubmitting && !disabled;

  const handleSubmit = () => {
    if (!canSubmit) {
      return;
    }

    onSubmit(promptText.trim());
    setPromptText('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className="flex items-center justify-between bg-white h-10 rounded-lg p-[4px] pl-[16px] gap-[16px]"
      >
        <input
          type="text"
          className="flex-[4] leading-5 text-sm font-normal focus:outline-none focus:border-primary-500
            transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          placeholder="Change this..."
          value={promptText}
          onChange={e => setPromptText(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={REFINEMENT_PROMPT_MAX_LENGTH + 1}
          disabled={isSubmitting || disabled}
        />
        <button
          type="button"
          className="flex-[2] h-full bg-primary-500 rounded-lg text-white text-xs font-medium leading-4
            hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          onClick={handleSubmit}
          disabled={!canSubmit}
        >
          {isSubmitting ? 'Generating…' : 'Generate variant'}
        </button>
      </div>
    </div>
  );
};

RefinementInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

RefinementInput.defaultProps = {
  isSubmitting: false,
  disabled: false,
};

export default RefinementInput;
